import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import '@aws-amplify/ui-vue';
import Amplify from 'aws-amplify';
// import awsconfig from './aws-exports';
import vuetify from './plugins/vuetify';

const appConfig = {
  "aws_project_region": "eu-west-2",
  "aws_appsync_graphqlEndpoint": "https://snmblzqllnfj5iv2qzv47b7vqq.appsync-api.eu-west-2.amazonaws.com/graphql",
  "aws_appsync_region": "eu-west-2",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_apiKey": "da2-jirlreuzzjbehdozijkd66yeeu",
  "aws_cognito_identity_pool_id": "eu-west-2:1ad306d4-2670-46d3-b314-143a3cbe0cf2",
  "aws_cognito_region": "eu-west-2",
  "aws_user_pools_id": "eu-west-2_10o9WTvm9",
  "aws_user_pools_web_client_id": "4lve9u3le28n62peh0cr2245dh",
  "oauth": {}
};

Amplify.configure(appConfig)

Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: 'eu-west-2:f49bffc9-84d2-4f7f-8a37-e2f0a750487c',

    // REQUIRED - Amazon Cognito Region
    region: 'eu-west-2',

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: 'eu-west-2_2HVDIm7Ho',

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: '6rq15a8q7ofmqd9m8b0a943f6h',

    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS'
  },
  Storage: {
    AWSS3: {
      bucket: 'hp-internal-document-storage',
      region: 'eu-west-2',
    }
  }
});

Vue.config.productionTip = false;

// Vue.use(AmplifyPlugin, AmplifyModules)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
